import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { comparisonRows } from "@/mocks/comparison";

export default function ComparisonSection() {
  return (
    <section className="bg-background-50 py-20 md:py-28">
      <div className="shell">
        <Reveal>
          <SectionHeading
            eyebrow="Hızlı karşılaştırma"
            title="Hangi film ne için?"
            description="Diş hekiminiz “şu filmi çektir” dediyse ya da hangi görüntülemenin size uygun olduğundan emin değilseniz, bu tablo yol gösterir."
          />
        </Reveal>

        <Reveal>
          <div className="mt-14 overflow-hidden rounded-xl border border-background-200 bg-background-50">
            <div className="overflow-x-auto">
              <table className="w-full min-w-[720px] border-collapse text-left">
                <caption className="sr-only">Dental görüntüleme yöntemlerinin karşılaştırması</caption>
                <thead>
                  <tr className="bg-primary-950">
                    <th scope="col" className="px-5 py-4 text-xs font-bold uppercase tracking-[0.14em] text-background-200">Hizmet</th>
                    <th scope="col" className="px-5 py-4 text-xs font-bold uppercase tracking-[0.14em] text-background-200">Ne zaman?</th>
                    <th scope="col" className="px-5 py-4 text-xs font-bold uppercase tracking-[0.14em] text-background-200">Süre</th>
                    <th scope="col" className="px-5 py-4 text-xs font-bold uppercase tracking-[0.14em] text-background-200">Detay</th>
                  </tr>
                </thead>
                <tbody>
                  {comparisonRows.map((row) => (
                    <tr key={row.name} className="border-t border-background-200 transition-colors hover:bg-accent-50">
                      <th scope="row" className="px-5 py-4 align-top">
                        <span className="block font-heading text-base font-medium text-foreground-950">
                          {row.name}
                        </span>
                        <span className="mt-0.5 block text-xs text-foreground-500">{row.note}</span>
                      </th>
                      <td className="px-5 py-4 align-top text-sm text-foreground-700">{row.when}</td>
                      <td className="px-5 py-4 align-top">
                        <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-background-100 px-3 py-1 text-xs font-semibold text-foreground-700">
                          <i className="ri-time-line text-sm text-primary-600" aria-hidden="true" />
                          {row.duration}
                        </span>
                      </td>
                      <td className="px-5 py-4 align-top">
                        <span className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-700">
                          <i className="ri-check-line text-base" aria-hidden="true" />
                          {row.detail}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </Reveal>

        <Reveal>
          <p className="mt-8 text-center text-sm text-foreground-600">
            Emin değilseniz{" "}
            <Link to="/iletisim" className="cursor-pointer font-semibold text-primary-700 underline decoration-primary-300 underline-offset-4 hover:text-primary-500">
              bize yazın
            </Link>
            , hekiminizin istediği filme göre yönlendirelim.
          </p>
        </Reveal>
      </div>
    </section>
  );
}